<template>
    <div class="Fol-Cadastro-Principal">
        <PageTitle icon="fa fa-group" main="Cadastro"
            sub="Cadastro -> Funcionários / Função / Indicadores" />
        <div class="Fol-Cadastro-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Funcionários" active><Funcionario /></b-tab>                                                                                                                        
                    <b-tab title="Funções" ><Funcao /></b-tab>                                                                                                                        
                    <b-tab title="Liberar Recibos para consulta" ><LiberaRecibo /></b-tab>                                                                                                                        
                                                                                                                                  
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import Funcionario from '../folhapagamento/Funcionario'
import Funcao from '../folhapagamento/FuncionarioFuncao'
import LiberaRecibo from '../folhapagamento/FuncionarioLiberaRecibos'

export default {
    name: 'FuncionarioPrincipal',    
    components: { PageTitle, Funcionario, Funcao,LiberaRecibo}
    
}
</script>

<style>

</style>






